import yup from 'utils/yup';

export const initialConnectFormData = {
  username: '',
  password: '',
  host: '',
  client_id: '',
  auth_guid: '',
  show_password: false,
};

export const connectFormValidationSchema = yup.object().shape({
  username: yup.string().required(),
  password: yup.string().required(),
  host: yup.string().required(),
  client_id: yup.string().required(),
  auth_guid: yup.string().required(),
});
